// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"Avatar_Avatar__196lW"};